import { Component, OnInit } from '@angular/core';
import { Product } from '@proximus/usage-business-logic';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getSelectedProductDetails,
} from '../../../../store/reducers';
import { InceptionService } from '@proximus/ng-common';
import { getUsageProductFrom } from '../../../../shared/usage/util';
import { Product as UsageProduct } from '@proximus/usage-business-logic/esmlib/models/product.model';
import { getPiiServiceId } from '../../../../shared/pii/pii.utils';
import { InternetProduct } from '@dch/products-business-logic';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { GetProductDetails } from '../../../../store/actions/product-details.actions';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'mprd-internet-usage-details',
  templateUrl: './internet-usage-details.component.html',
})
export class InternetUsageDetailsComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  selectedProduct: InternetProduct;
  usageProduct: UsageProduct;
  usageDetails: Product;
  showLoadingSpinner = true;

  constructor(
    private store: Store<ApplicationState>,
    private inceptionService: InceptionService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.addSubscription(
        this.store.select(getSelectedProductDetails).subscribe((value) => {
          if (value && value.internetProductDetails) {
            this.selectedProduct = value.internetProductDetails;
            this.showLoadingSpinner = false;
            this.usageProduct = getUsageProductFrom(this.selectedProduct);
          }
        }),
      );
      this.addSubscription(
        this.route.params.subscribe((params) => {
          this.store.dispatch(
            new GetProductDetails({
              productType: 'internet',
              serviceId,
            }),
          );
        }),
      );
    }
  }
  private scrollToFragment(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#internetUsageDetails');
    });
  }
}
